export default __webpack_public_path__ + "static/media/5.4dc8da03.png";